import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PrivateRoute from './PrivateRoute';

import Booking from './Booking/Booking'
import BookingZones from './Booking/Zones'
import BookingVentilations from './Booking/Ventilation'
import BookingStats from './Booking/Stats'
import BookingHebergements from './Booking/Hebergements'
import Benchmark from './Booking/Bench'
import BookingTutorial from './Booking/Tutorial'

import './App.css';

import Home from './Home'
import NavBar from "./NavBar"

import Neo4Tourism from './Neo4Tourism/Neo4Tourism'
import Map_A1 from './Neo4Tourism/Map/Map_A1'
import Map_A2 from './Neo4Tourism/Map/Map_A2'
import Map_A3 from './Neo4Tourism/Map/Map_A3'
import Stats from "./Neo4Tourism/Stats"
import Tutorial from "./Neo4Tourism/Tutorial"
import SignIn from './Login/Login';

/* eslint eqeqeq: 0 */

function App() {
  return (
    <div>
      <Helmet>
          <title>DVRC | {global.title}</title>
      </Helmet>
      <div className="App">
        <NavBar></NavBar>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route exact path="/Neo4Tourism" element={<Neo4Tourism/>}/>
          <Route exact path="/Neo4Tourism/Region" element={<PrivateRoute><Map_A1/></PrivateRoute>}/>
          <Route exact path="/Neo4Tourism/Department" element={<PrivateRoute><Map_A2/></PrivateRoute>}/>
          <Route exact path="/Neo4Tourism/District" element={<PrivateRoute><Map_A3/></PrivateRoute>}/>
          <Route exact path="/Neo4Tourism/Stats" element={<PrivateRoute><Stats/></PrivateRoute>}/>
          <Route exact path="/Neo4Tourism/Tutorial" element={<Tutorial/>}/>
          <Route exact path="/Booking" element={<Booking/>}/>
          <Route exact path="/Booking/Zones" element={<PrivateRoute><BookingZones/></PrivateRoute>}/>
          <Route exact path="/Booking/Ventilation" element={<PrivateRoute><BookingVentilations/></PrivateRoute>}/>
          <Route exact path="/Booking/Stats" element={<PrivateRoute><BookingStats/></PrivateRoute>}/>
          <Route exact path="/Booking/Hebergements" element={<PrivateRoute><BookingHebergements/></PrivateRoute>}/>
          <Route exact path="/Booking/Bench" element={<PrivateRoute><Benchmark/></PrivateRoute>}/>
          <Route exact path="/Booking/Tutorial" element={<PrivateRoute><BookingTutorial/></PrivateRoute>}/>
          <Route exact path="/Login/Login" element={<SignIn/>}/>
        </Routes>
      </div>
    </div>
  );
}

export default App;
